export var currencySymbols = {
	left: {
		US: "$"
	},
	right: {
	}
};
export var euHempCountries = {
};
export default {
	currencySymbols: currencySymbols,
	euHempCountries: euHempCountries
};
